import isArrayLike from './is-array-like';
var map = function (arr, func) {
  if (!isArrayLike(arr)) {
    // @ts-ignore
    return arr;
  }
  var result = [];
  for (var index = 0; index < arr.length; index++) {
    var value = arr[index];
    result.push(func(value, index));
  }
  return result;
};
export default map;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_util@2.0.17@@antv/util/esm/map.js
// module id = 104
// module chunks = 0